<template>
	<div
		v-if="isVisible"
		:class="[
			'sticky-banner',
			color,
			{ 'sticky-banner--hidden': isSideNavOpen },
		]"
	>
		<a :href="link.url" class="sticky-banner__text" @click="pushTracking">
			{{ link.text }}
		</a>
		<button
			@click.prevent="close"
			:aria-label="ariaClose"
			class="sticky-banner_close"
		>
			<SvgIcon icon="x" />
		</button>
	</div>
</template>

<script setup>
const store = useAppStore();

const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const gtm = computed(() => props.fields?.gtm?.value);
const link = computed(() => props.fields?.link?.value);
const color = computed(() => props.fields?.color?.value);
const ariaClose = computed(
	() => props.fields?.ariaClose?.value || "Close Banner",
);

const isVisible = ref(false);
const isSideNavOpen = computed(() => store.isSideNavOpen);

const cookieId = computed(() => {
	return `sticky-banner-dismissed-${props.rendering?.dataSource}`;
});

onMounted(() => {
	const cookie = useCookie(cookieId.value);
	if (!cookie || cookie.value !== true) {
		isVisible.value = true;
	}
});

function close() {
	const cookie = useCookie(cookieId.value);
	cookie.value = "true";
	isVisible.value = false;
}

const { pushGa4 } = useTracking();
function pushTracking() {
	pushGa4(gtm.value);
}
</script>

<style lang="scss">
.component--stickybanner {
	padding: 0 16px;
}

.sticky-banner {
	position: relative;
	align-items: center;
	display: flex;
	font-size: var(--text-sm, 14px);
	font-style: normal;
	font-weight: 400;
	line-height: 140%;
	z-index: 22;
	width: 100%;
	border-radius: 12px;

	&.sticky-banner--hidden {
		display: none;
	}

	.sticky-banner_close {
		align-items: center;
		aspect-ratio: 1;
		width: 36px;
		background-color: transparent;
		border: 0;
		display: flex;
		justify-content: center;
		padding: var(--spacing-05, 4px);
		position: relative;
		position: absolute;
		right: 0;
		top: 0;
		bottom: 0;

		&:hover {
			cursor: pointer;
		}
	}

	.sticky-banner__text {
		width: 100%;
		padding: var(--spacing-105, 12px) 36px var(--spacing-105, 12px)
			var(--spacing-4, 32px);
		text-align: center;
	}

	&.white {
		background: var(--color-white, #fff);
		color: var(--color-black, #000);

		.sticky-banner__text {
			color: var(--color-black, #000);
		}

		.sticky-banner_close path {
			fill: var(--color-black, #000);
		}
	}

	&.black {
		background: var(--color-black, #000);
		color: var(--color-white, #fff);

		.sticky-banner__text {
			color: var(--color-white, #fff);
		}

		.sticky-banner_close path {
			fill: var(--color-white, #fff);
		}
	}

	&.orange,
	&.primary {
		background: var(--primary-color, #fd470b);
		color: var(--color-white, #fff);

		.sticky-banner__text {
			color: var(--color-white, #fff);
		}

		.sticky-banner_close path {
			fill: var(--color-white, #fff);
		}
	}

	&.secondary {
		background: var(--secondary-color, #fd470b);
		color: var(--color-black, #000);

		.sticky-banner__text {
			color: var(--color-black, #000);
		}

		.sticky-banner_close path {
			fill: var(--color-black, #000);
		}
	}

	&.tertiary {
		background: var(--tertiary-color, #384039);
		color: var(--color-white, #fff);

		.sticky-banner__text {
			color: var(--color-white, #fff);
		}

		.sticky-banner_close path {
			fill: var(--color-white, #fff);
		}
	}
}
</style>
